import { useLocation } from "react-router-dom";
import Breadcrumb from "../app/sections/common/breadcrumb";

function InnerPageLayout(props) {
    const currentpath = useLocation().pathname;
    const breadcrumb = props.breadcrumb;
    
    return (
        <>
            {/* Inner Banner */}
            <Breadcrumb breadcrumb={breadcrumb} />

            {
                props.content
            }
        </>
    )
}
export default InnerPageLayout;